<template>
  <vxe-table border resizable show-overflow :data="tableData">
    <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
    <vxe-table-column
      v-for="(item, index) of tableColumn"
      :key="index"
      :field="item.field"
      :title="item.title"
      :edit-render="item.itemRender"
      :width="item.width"
    >
    </vxe-table-column>
  </vxe-table>
</template>

<script>
  export default {
    name: 'ExpandTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
      dateStart: {
        type: String,
        default: '',
      },
      dateEnd: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        tableData: [],
        tableColumn: [
          {
            title: '收款金额',
            field: 'originReceiveMoneyAmount',
          },
          {
            title: '收款单号',
            field: 'docNo',
          },
          {
            title: '收款日期',
            field: 'registerDate',
          },
          // {
          //   title: '费用期间',
          //   field: 'expensePeriod',
          // },
        ],
      };
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.tableData = val;
            this.tableData.forEach(
              (item) => (item.expensePeriod = this.dateStart + '-' + this.dateEnd)
            );
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style></style>
